export enum ClientDirectoryFilterOptionIdEnum {
  Admins = 1,
  Country,
  Billing,
  PermissionType,
}
